import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { creatorsReportEndpointIds } from 'root/src/shared/creatorsReport/creatorsReport.constants';
import { authenticationTypes } from 'root/src/shared/constants/auth';
import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
import { CreatorsReportFilter } from 'root/src/server/modules/creatorsReport/creatorsReport.constants';
export const generateCreatorsReportEndpoint = {
    [creatorsReportEndpointIds.GENERATE_CREATORS_REPORT]: {
        endpointType: otherEndpointType,
        authentication: authenticationTypes.authenticated,
        authenticationRole: AuthGroup.Admin,
        payloadSchema: {
            type: 'object',
            properties: {
                filterName: {
                    type: 'string',
                    enum: Object.values(CreatorsReportFilter),
                },
                filterValue: { type: 'string' },
            },
            required: [],
        },
    },
};
